import axios from 'axios';

export const GET_CONTATOS = '[CHAT PANEL] GET CONTATOS';
export const SET_SELECTED_CONTACT_ID = '[CHAT PANEL] SET SELECTED CONTACT ID';
export const REMOVE_SELECTED_CONTACT_ID = '[CHAT PANEL] REMOVE SELECTED CONTACT ID';

export function getContacts()
{
    const request = axios.get('/api/chat/Contatos');
    return (dispatch) =>
        request.then((response) =>
            dispatch({
                type   : GET_CONTATOS,
                payload: response.data
            })
        );
}

export function setselectedContactId(contactId)
{
    return {
        type   : SET_SELECTED_CONTACT_ID,
        payload: contactId
    }
}

export function removeSelectedContato()
{
    return {
        type: REMOVE_SELECTED_CONTACT_ID
    }
}
